import React, { useEffect, useState } from "react";
import { useDrag, useDrop, DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import { useForm } from "react-hook-form";

const FormField = ({ field, index, moveField, removeField }) => {
  const { register } = useForm();
  const [{ isOver }, drop] = useDrop({
    accept: "field",
    hover: (draggedItem) => moveField(draggedItem, index),
    collect: (monitor) => ({
      isOver: !!monitor.isOver(),
    }),
  });

  // Prevent multiple DndProviders from rendering
  const [isDndInitialized, setIsDndInitialized] = useState(false);

  useEffect(() => {
    if (!isDndInitialized) {
      setIsDndInitialized(true);
    }
  }, []);

  const fieldContent = (
    <div ref={drop} className="form-field" style={{ background: isOver ? "#f0f0f0" : "white" }}>
      {field.type === "text" && <input type="text" placeholder="Text field" {...register(`field_${index}`)} />}
      {field.type === "dropdown" && (
        <select {...register(`field_${index}`)}>
          <option value="">Select</option>
          <option value="option1">Option 1</option>
          <option value="option2">Option 2</option>
        </select>
      )}
      {field.type === "date" && <input type="date" {...register(`field_${index}`)} />}
      <button type="button" onClick={() => removeField(index)}>X</button>
    </div>
  );

  return isDndInitialized ? (
    <DndProvider backend={HTML5Backend}>{fieldContent}</DndProvider>
  ) : (
    fieldContent
  );
};

export default FormField;
